import { useEffect, useState } from 'react';

/* Useful hook for listening for changes to the active element */
export const useActiveElement = () => {
  const [activeElement, setActiveElement] = useState(document.activeElement);

  const handleFocusIn = () => {
    setActiveElement(document.activeElement);
  };

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return activeElement;
};
